import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import teraber_coin_logo from 'assets/images/terabet_coin_logo.png';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectBalance, selectCurrentCurrency, setCurrentCurrency } from 'features/home/homeSlice';
import { formatAmountV2 } from 'utils/formatAmount';
import { useHandleGetWallets } from 'hooks/useHandleGetWallets';
import { getLocalStorage, setLocalStorage } from 'utils/sessionStorage';
import useUserDetail from 'hooks/useUserDetail';
import { CoinMarketPriceResponseModel } from 'models/wallet';
import { Tooltip } from 'antd';
import walletApi from 'api/walletApi';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

interface CurrencySwicherProps {
  isReverse?: boolean;
}

const CurrencySwicher: React.FunctionComponent<CurrencySwicherProps> = ({ isReverse }) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [coinPrice, setCoinPrice] = useState<CoinMarketPriceResponseModel | null>(null);
  const balance = useAppSelector(selectBalance);
  const currentCurrency = useAppSelector(selectCurrentCurrency);
  const dispatch = useAppDispatch();
  const { getWallet, currentWallet } = useHandleGetWallets();
  const { isUserLoggedIn } = useUserDetail();
  const [showAtr, setShowAtr] = useState<boolean>(false);

  useEffect(() => {
    if (getLocalStorage('currentCurrency') === '$TBET') {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, []);

  const handleCoinChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.type === 'checkbox' && event.target.name === 'currency') {
      const newChecked = !checked;
      setChecked(newChecked);
      const newCurrency = newChecked ? '$TBET' : 'USD';
      dispatch(setCurrentCurrency(newCurrency));
      setLocalStorage('currentCurrency', newCurrency);
    }
  };

  const getPrice = async () => {
    if (currentCurrency !== 'USD') {
      const { ok, body } = await walletApi.getTokenPrice(currentCurrency);
      if (ok && body) {
        setCoinPrice(body);
      }
    }
  };

  useEffect(() => {
    getPrice();
    let idInterval: any = -1;
    if (isUserLoggedIn) {
      getWallet();
      idInterval = setInterval(() => {
        getWallet();
      }, 5000);
    }

    return () => {
      if (idInterval !== -1) clearInterval(idInterval);
    };
  }, [isUserLoggedIn, currentCurrency]);

  const renderTooltip = useMemo(() => {
    if (coinPrice?.price && currentCurrency !== 'USD') {
      return `$ ${Number(currentWallet?.balance) * coinPrice?.price}`;
    }
  }, [coinPrice?.id, currentCurrency, currentWallet]);

  const handleShowAtr = () => {
    setShowAtr((prev) => !prev);
  };

  return (
    // <div className={`switcher__theme__container ${isReverse ? 'is_reverse' : ''}`}>
    //   <label className="switcher__theme">
    //     <div className="switcher__theme__toggle-wrap">
    //       <input
    //         className="switcher__theme__toggle"
    //         type="checkbox"
    //         role="currency"
    //         name="currency"
    //         checked={currentCurrency !== 'USD'}
    //         onChange={handleCoinChange}
    //       />
    //       <span className="switcher__theme__icon">
    //         <img
    //           src={
    //             currentCurrency !== 'USD'
    //               ? teraber_coin_logo
    //               : 'https://s2.coinmarketcap.com/static/cloud/img/fiat-flags/USD.svg'
    //           }
    //           className="switcher__theme__img"
    //         />
    //       </span>
    //     </div>
    //   </label>
    //   {currentWallet?.coin.symbol === '$TBET' ? (
    //     <Tooltip title={renderTooltip} placement="bottomLeft">
    //       <span className={`primary-text-color  switcher__theme__amount`}>
    //         {`$TBET ${formatAmount(balance, 8)}`}
    //       </span>
    //     </Tooltip>
    //   ) : (
    //     <span className={`primary-text-color switcher__theme__amount`}>
    //       {formatMoney(balance, 0)}
    //     </span>
    //   )}
    // </div>

    <span className={`primary-text-color  switcher__theme__amount flex flex-row items-center `}>
      <button className="hidden-show-button primary-text-color" onClick={handleShowAtr}>
        {showAtr ? <BsEyeSlash /> : <BsEye />}
      </button>
      <span className={showAtr ? 'balance-text' : ''}>
        {showAtr ? formatAmountV2(balance, 2) : '**'}
      </span>
      <img src={teraber_coin_logo} width={20} height={20} />
    </span>
  );
};

export default CurrencySwicher;
